
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'BaseImg',
  props: {
    icon: String,
    type: {
      type: String,
      default: 'svg'
    }
  }
})
